<template>
  <div class="single_sentence_writing">
    <precautions :level="level" :unit="unit" v-if="selectedStep === 0" :title="questionData.Name"/>
    <div class="flex justify-center mt-5" v-if="selectedStep === 0">
      <a class="inline-block gept_main_bg4 text-white px-16 py-2 rounded-full mx-auto cursor-pointer font-bold" @click="getStart()">START</a>
    </div>
    <div v-if="selectedStep === 1 && qData" class="single_sentence_writing_inner p-3 lg:p-6">
      <div class="flex justify-between items-center bg-white mb-2 instruction-card">
        <div class="flex items-center p-4">
          <h6 class="font-black text-left">請依題目之提示，將原句改寫成指定型式，並將改寫的句子完整地寫在答案卷上（包括提示之文字及標點符號）。</h6>
        </div>

        <div class="flex items-center p-3">
          <!-- <div class="p-2 border-2 rounded m-1 gept_main_color10 border_main10 font-black">已輸入 <span class="gept_main_color4">{{ textLength }}</span> 個單字</div> -->
          <div class="p-2 border-2 rounded m-1 gept_main_color4 border_main2 font-black timer-box">{{ formatTime(answer_count) }}</div>
        </div>
      </div>

      <div class="writing_inner scroll-bar mb-3">
        <div v-for="(item, index) in qData" :key="index">
          <div class="bg-white p-6 my-3 text-left section-card">
            <p class="gept_main_color text-xl font-black mb-3 text-left">第{{labels[index]}}部分　{{ item.Name }}</p>
            <p class="font-black">{{ item.Description }}</p>
          </div>
          <div class="flex question-row" v-for="(child, index2) in item.Questions" :key="index2">
            <div class="w-1/2 p-2 col question-column">
              <div class="">
                <div class="bg-white flex items-center rounded overflow-hidden h-full question-card">
                  <div class="py-6 gept_main_bg7 text-white w-16 text-center h-full question-index">{{ index2 + 1 }}</div>
                  <div class="flex-1 p-2 font-bold question-text" v-html="return_user_text(child.Title)"></div>
                  <!-- <a class="tips p-2 rounded cursor-pointer" @click="toggleTips(index, index2)" :class="{ 'opacity-0': selectTipsIdx === index && selectTipsIdx2 === index2 }">
                    <img src="@/assets/image/gept/tips3.png" alt="" class="object-contain block w-4/5">
                  </a> -->
                </div>
                <!-- <div class="gept_main_bg_light0 flex items-center rounded overflow-hidden" v-if="selectTipsIdx === index && selectTipsIdx2 === index2">
                  <div class="p-3 gept_main_bg5 text-white w-16 text-center">提示</div>
                  <div class="flex-1 p-2 font-bold">{{ child.Description }}</div>
                  <a class="tips p-2 rounded cursor-pointer" @click="toggleTips(-1, -1)">
                    <img src="@/assets/image/gept/clode_btn2.png" alt="" class="object-contain block w-4/5">
                  </a>
                </div> -->
              </div>
            </div>
            <div class="w-1/2 p-2 col answer-column">
              <div>
                <textarea v-model="child.Answer" :disabled="!isCanActive" name="textarea" :id="`textarea${index}${index2}`" cols="30" rows="2" class="bg-white w-full p-3 answer-textarea" placeholder="請作答 ..."></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center">
        <!-- <a class="inline-block gept_main_bg4 text-white px-16 py-2 rounded-full mx-3 cursor-pointer font-bold" @click="textVal = null">清除作答框</a> -->
        <a class="inline-block gept_main_bg5 text-white px-16 py-2 rounded-full mx-3 cursor-pointer font-bold" @click="toggleReport()">{{ !isLastGroup && $route.name === 'formal_exam' ? '前往下一個題型' : '交卷看報告' }}</a>
      </div>
    </div>

    <!-- <ReportModal v-if="showfirstModal" :showfirstModal="showfirstModal" v-on:closeModal="showfirstModal = false" :selectItemIdx="selectItemIdx" :ERS_arr="ERS_arr" :questionData="questionData" /> -->
  </div>
</template>

<script>
  import api from '@/api'
  import precautions from '@/components/GEPT/precautions'
  import allJs from '@/components/all.js'
  import formal_examJs from '@/components/formal_exam.js'
  export default {
    name: 'single_sentence',

    data () {
      return {
        labels: ['一', '二', '三'],
        isShowTitle: false,
        isCanActive: false, // 可以動作

        selectedStep: 0,
        questionNumber: 0, //第幾題

        selectTipsIdx: -1,
        selectTipsIdx2: -1,

        timer: null,

        // 回答
        answer_count: 0,
        textVal: null,

        qData: null

        // selectItemIdx: -1
      }
    },
    mixins: [
      allJs,
      formal_examJs
    ],
    props: {
      questionData: {
        type: Array
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      }
    },
    components: {
      precautions
    },
    computed: {
      textLength () {
        if (this.textVal) {
          let words = this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
          let wordCount = words.filter(word => word.length > 0).length
          return wordCount
        }
        return 0
      }
    },
    mounted () {
    },
    methods: {
      getStart () {
        this.selectedStep = 1
        this.isCanActive = true
        this.setArray()
        this.stopWatch()
      },

      setArray () {
        if (this.questionData) {
          this.qData = this.questionData
        }
      },

      stopWatch () {
        let self = this
        self.timer = setInterval(() => {
            self.answer_count++

            if (self.answer_count === 1 * 60 * 60) {
              clearInterval(self.timer)
              self.isCanActive = false
            }
          }, 1000
        )
      },

      formatTime (seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60

        const formattedTime = [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':')

        return formattedTime
      },

      reStart () {
        Object.assign(this.$data, this.$options.data())
      },

      alertTips () {
        let self = this
        return self.$swal.fire({
          title: '作答提示',
          html: '【段落寫作】這個部分的寫作採整體式的評分再轉換成百分制，需要花費的時間跟分數比重都較多，需要閱讀提示的文字用英文描寫出圖片情節約50字的短文，評分的重點包含文字表達完整度、文法、拼字、大小寫、標點符號等。<br/><br/>文章第一句可先說明全文主旨，接著內容依照時間順序描寫、切記不要離題或加入不相關的內容，中間善用轉折詞能讓文章結構更為清楚，最後結論可以加入自己對這件事的看法或感受。 試著用關鍵字先描述圖片中的動作或情節，注意時態是過去式或是現在式並且把3張圖片都串聯起來，把各個句子連接起來之後，要再注意文法上有沒有使用錯誤尤其是動詞時態、名詞單複數。',
          showCloseButton: true,
          showConfirmButton: false,
          focusConfirm: false,
          showDenyButton: false,
          customClass: {
            container: '',
            popup: 'p-0 max-w-3xl w-full',
            header: 'py-5 text-white gept_main_bg',
            title: 'text-white m-0 text-2xl',
            closeButton: '',
            htmlContainer: 'p-4 font-bold leading-loose mb-6 text-left',
            actions: 'mb-4 mt-5',
            confirmButton: 'submitButton-gept',
            denyButton: 'denyButton-gept',
          }
        })
      },

      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false
        let allAnswersFilled = self.qData.every(section => section.Questions.every(question => question.Answer.trim() !== ""))

        if (allAnswersFilled) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.query.record_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam' && !self.isLastGroup) {
            for (let value of self.qData) {
              for (let value2 of value.Questions) {
                let qId = value2.Id
                let Name = value.Name
                let Answer = value2.Answer
                await self.post_gept_records_byFormal(self.$route.query.record_id, qId, Name, Answer, null)
              }
            }
            self.$nextTick(() => {
              if (!self.isLastGroup) {
                self.$emit('guideNextType')
              } else {
                self.post_gept_records_finish(self.$route.query.record_id)
              }
            })
          }
        } else {
          self.$swal.fire({
            title: '作答提示',
            html: '<p>尚有句子未完成</p>',
            showCloseButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            showDenyButton: false,
            customClass: {
              container: '',
              popup: 'p-0 max-w-xl w-full',
              header: 'py-5 text-white gept_main_bg',
              title: 'text-white m-0 text-2xl',
              closeButton: '',
              htmlContainer: 'p-6 font-bold leading-loose text-center text-lg',
              actions: 'mb-4 mt-5',
              confirmButton: 'submitButton-gept',
              denyButton: 'denyButton-gept',
            }
          })
        }
      },

      toggleTips (idx, idx2) {
        this.selectTipsIdx = idx
        this.selectTipsIdx2 = idx2
      },

      return_user_text (text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      }
    }
  }
</script>

<style lang="scss" scoped>
.single_sentence_writing {
  .single_sentence_writing_inner {
    .writing_inner {
      height: calc(61vh);
      overflow-y: scroll;
    }
    .instruction-card {
      gap: 0.5rem;
    }
    .timer-box {
      white-space: nowrap;
    }
    .section-card {
      line-height: 1.5;
    }
    .question-card {
      min-height: 100%;
    }
    .question-index {
      align-items: center;
      display: flex;
      flex: 0 0 4rem;
      justify-content: center;
    }
    .question-text {
      line-height: 1.5;
      min-width: 0;
      overflow-wrap: anywhere;
    }
    .answer-textarea {
      line-height: 1.5;
      min-height: 88px;
      resize: vertical;
    }
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }

    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    @media (max-width: 767.98px) {
      & {
        padding: 0.75rem !important;
      }
      .instruction-card {
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 0.75rem;
        padding: 0.75rem !important;
      }
      .instruction-card h6 {
        font-size: 1rem;
        line-height: 1.65;
      }
      .timer-box {
        margin-left: auto !important;
      }
      .writing_inner {
        height: calc(100vh - 250px);
        min-height: 360px;
        overflow-x: hidden;
        padding-right: 2px;
      }
      .section-card {
        margin: 0.75rem 0 !important;
        padding: 1rem !important;
      }
      .section-card p:first-child {
        font-size: 1.05rem;
        line-height: 1.4;
      }
      .question-row {
        flex-direction: column;
        margin-bottom: 0.85rem;
      }
      .question-column,
      .answer-column {
        padding: 0.35rem 0 !important;
        width: 100% !important;
      }
      .question-card {
        align-items: stretch;
        min-height: auto;
      }
      .question-index {
        flex-basis: 2.625rem;
        padding-bottom: 0 !important;
        padding-top: 0 !important;
        width: 2.625rem !important;
      }
      .question-text {
        font-size: 1rem;
        line-height: 1.45;
        padding: 0.75rem !important;
      }
      .answer-textarea {
        font-size: 1rem;
        min-height: 84px;
      }
      .flex.justify-center > a {
        max-width: 280px;
        padding-left: 1rem !important;
        padding-right: 1rem !important;
        text-align: center;
        width: 100%;
      }
    }    .item_text {
      min-height: 120px;
      height: 20%;
    }

  }
}
</style>
